module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.7122aedc.webp";